import { RootState } from "../store";
import { PropsWithChildren, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


const ConsoleLayout = (props: PropsWithChildren) => {

 const { auth:{ user }  } =  useSelector(( state:RootState)=> state)
 const router = useNavigate()

  useEffect(() => {
    if( !user ){
       router('/login')
    }
  },[
    user
  ])

  return (
    <>
        { props.children}
    </>
  );
};

export default ConsoleLayout;
